import { RpeFieldRegistry } from 'src/app/shared/rpe/rpe.model';
import { BAG_RPE_ATTACHMENTS_TAB_ID, BAG_RPE_INVALID_TAB_AND_LEGEND_ID, BAG_RPE_MISCELLANEOUS_TAB_ID, BAG_RPE_NOTES_TAB_ID, BAG_RPE_STATUSCODES_TAB_ID } from './bag-rpe.constants';

export const BAG_RPE_FIELD_REGISTRY: RpeFieldRegistry = [
  {
    binding: {
      tabId: BAG_RPE_INVALID_TAB_AND_LEGEND_ID,
      legendId: BAG_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'manifestNumber',
    },
  },
  {
    binding: {
      tabId: BAG_RPE_INVALID_TAB_AND_LEGEND_ID,
      legendId: BAG_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'description',
    },
  },
  {
    binding: {
      tabId: BAG_RPE_MISCELLANEOUS_TAB_ID,
      legendId: BAG_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'tareWeight',
    },
  },
  {
    binding: {
      tabId: BAG_RPE_STATUSCODES_TAB_ID,
      legendId: BAG_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'additionalDetails',
    },
  },
  {
    binding: {
      tabId: BAG_RPE_NOTES_TAB_ID,
      legendId: BAG_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'ibc',
    },
  },
  {
    binding: {
      tabId: BAG_RPE_NOTES_TAB_ID,
      legendId: BAG_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'customer',
    },
  },
  {
    binding: {
      tabId: BAG_RPE_ATTACHMENTS_TAB_ID,
      legendId: BAG_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'description',
    },
  },
];